import { Schemas } from '../../../../../openapi/generated/types';
import { ReservationFlowInvalidRequestError } from '../../../../../interfaces/reservation_flow';

export function isReservationFlowInvalidRequestError(
  error: Schemas.APIError,
): error is ReservationFlowInvalidRequestError {
  // detailsにreservation_flow_invalid_requestが含まれているかどうかで判定する
  return error.details.every(
    (detail) => detail.type === 'reservation_flow_invalid_request',
  );
}
